import { render, staticRenderFns } from "./ApmsRegAnnualYieldForecastDetail.vue?vue&type=template&id=de54808a&scoped=true&"
import script from "./ApmsRegAnnualYieldForecastDetail.vue?vue&type=script&lang=js&"
export * from "./ApmsRegAnnualYieldForecastDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de54808a",
  null
  
)

export default component.exports